import { render, staticRenderFns } from "./LeaveWasApproved.vue?vue&type=template&id=0b841101"
import script from "./LeaveWasApproved.vue?vue&type=script&lang=js"
export * from "./LeaveWasApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports